import { useEffect } from 'react';
import { useFeatureContext } from 'contexts/FeatureContext.jsx';

const resourceCenterContainerId = 'pendo-resource-center-container';

const usePendoCustomBehaviors = () => {
  const { features } = useFeatureContext();
  const { pendoSupportEnabled } = features;

  // Use an observer to react when Pendo resource center is opened or closed.
  useEffect(() => {
    if (!pendoSupportEnabled) return;

    const handleClick = ({ target }) => {
      if (!target) return;
      const resourceCenterContainer = document.getElementById(resourceCenterContainerId);
      if (!resourceCenterContainer) return;
      if (resourceCenterContainer.contains(target)) return; // Clicked inside the resource center, do nothing.
      if (typeof target.className === 'string' && target.className.indexOf('pendo-') > -1) return; // Clicked on a Pendo element, do nothing.

      // Clicked outside the resource center, hide it.
      window.pendo?.guides?.forEach((guide) => guide?.hide?.());
    };

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.id === resourceCenterContainerId) {
              // When the resource center is opened, add a click listener to the
              // window to detect clicks outside the resource center.
              setTimeout(() => {
                window.addEventListener('click', handleClick);
              }, 0);
            }
          });
          mutation.removedNodes.forEach((node) => {
            if (node.id === resourceCenterContainerId) {
              // When the resource center is closed, remove the click listener.
              window.removeEventListener('click', handleClick);
            }
          });
        }
      }
    });

    observer.observe(document.body, { childList: true });

    return () => {
      observer.disconnect();
      window.removeEventListener('click', handleClick);
    };
  }, [pendoSupportEnabled]);
};

export default usePendoCustomBehaviors;
